import React from 'react';
import { storiesOf } from '@storybook/react';
import AliasesResultRow from './AliasesResultRow';
import { RowHeader } from '../EntriesResults';

storiesOf('Advanced Search/Result Rows', module)
  .add('Aliases', () => (
    <div className="result-item">
      <RowHeader row={row} />
      <div className="result-item-body">
        <AliasesResultRow row={row} />
      </div>
    </div>
  ));

const row = {
  case: {
    date_plan_confirmed: null,
    chapter: 11,
    case_nature_of_suit_code: null,
    index_timestamp: 1567082914,
  },
  case_assets: "Unknown",
  case_chapter: 11,
  case_court: "nysbke",
  case_date_filed: "03/10/2014",
  case_judge_name: "Martin Glenn",
  case_liabilities: "Unknown",
  case_naics_code: null,
  case_nature_of_suit_code: null,
  case_no: "1:14-bk-10557",
  case_title: "Sbarro LLC",
  case_type: "bk",
  case_uuid: "nysbke_247775",
  date_filed: "08/29/2019",
  document_type: "alias",
  id: "alias:nysbke_247775--Sbarro LLC",
  index_timestamp: 1567082848,
  party: {
    address: "401 Broadhollow Road↵Melville, NY 11747",
    email: null,
    fax: null,
    name: '<span class="highlight">Sbarro</span> LLC',
    participant_id: 668034,
    phone: null,
    role: "Debtor",
  },
  party_alias: [{
    modified: "2014-04-23 16:44:34.421029+00",
    name: 'New <span class="highlight">Sbarro</span> LLC',
    role: "aka",
  }],
  query: "alias",
  timestamp: 1567082848,
  type_code: 11,
};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/AliasesResultRow.stories.jsx